var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.vip.switch && _vm.zxtVisible)?_c('div',{staticClass:"basic_vip_header"},[_c('img',{staticClass:"header_vip_logo",attrs:{"src":("https://staticjs.71360.com/3/static/image/" + (_vm.$store.state.vip.level) + "_years.png")}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79b3880c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/basic_vip_header/index.vue
// module id = null
// module chunks = 